export const LogoMark = ({ className = "h-9 w-9" }) => (
  <span
    role="img"
    aria-label="Construction Alliance logo"
    className={`inline-block bg-current ${className}`}
    style={{
      maskImage: "url(/images/logo-mark.png)",
      WebkitMaskImage: "url(/images/logo-mark.png)",
      maskSize: "contain",
      WebkitMaskSize: "contain",
      maskRepeat: "no-repeat",
      WebkitMaskRepeat: "no-repeat",
      maskPosition: "center",
      WebkitMaskPosition: "center",
    }}
  />
);

export const Logo = ({ light = false }) => (
  <span className={`flex items-center gap-3 ${light ? "text-bone" : "text-ink"}`} data-testid="nav-brand-logo">
    <LogoMark className="h-9 w-9" />
    <span className="font-display font-semibold tracking-[-0.015em] text-sm sm:text-lg leading-none whitespace-nowrap">
      Construction Alliance
    </span>
  </span>
);
